import React from "react";
import OrderTable from "../Table";

const Delivered = () => {
  return <OrderTable type="Delivered" />;
};

export default Delivered;
